module.exports = __webpack_public_path__ + "static/media/marker.a50e60f8.svg";